import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StrikeMethod } from 'client/voladeum/strike-methods/types';
import { SLICE } from 'ducks/slice';

import { EMPTY_ARRAY } from '../../constants';

const initialState: StrikeMethod[] = EMPTY_ARRAY;

export const strikeMethodsSlice = createSlice({
  name: SLICE.STRIKE_METHODS,
  initialState,
  reducers: {
    setStrikeMethods: (_state, action: PayloadAction<StrikeMethod[]>) => {
      return action.payload;
    },
    clearStrikeMethods: () => {
      return initialState;
    },
  },
});

export const { setStrikeMethods, clearStrikeMethods } = strikeMethodsSlice.actions;

export default strikeMethodsSlice.reducer;
